<div
  [class.fill-horizontally]="fillHorizontally"
  [class.fill-vertically]="fillVertically"
  [class.is-loading]="isLoading() && sources.length"
  class="image-shape {{ shape() }}"
>
  @let visibleImages = visibleImages$$ | async;
  @let showInitials = imageFormat() === 'initials';

  @if (showInitials) {
    <!-- Initials: always show initials even when image is present -->
    <div class="image-wrap" [style]="wrapStyles()">
      <ng-template [ngTemplateOutlet]="initialsTpl" />
    </div>
  }

  <!-- Image format with sources -->
  @else if (sources.length) {
    <div class="image-wrap" [style]="wrapStyles()">
      @if (!loadImageFailed()) {
        @for (source of sources; track $index) {
          <img
            #imgTag
            (click)="useExternalClickAction && externalClickAction($event, source, imgTag)"
            (error)="onImageError()"
            (keydown.enter)="useExternalClickAction && externalClickAction($event, source, imgTag)"
            (load)="onImageLoaded()"
            [attr.data-source]="source"
            [class.invisible]="!visibleImages || !visibleImages.has(source)"
            [src]="source"
            [style]="imageStyles()"
            [tabindex]="0"
            alt=""
            class="image"
            loading="lazy"
          />
        }
      } @else {
        <div class="image error" [style.--icon-size]="errorIconSize">
          <mat-icon svgIcon="icon_dummy_32" />
        </div>
      }
    </div>
  }

  <!-- Image fallback -->
  @else if (emptyThumbnailIcon) {
    <div class="image-wrap" [style]="wrapStyles()">
      <ng-template [ngTemplateOutlet]="emptyThumbnail" />
    </div>
  }

  <div class="actions">
    @if (visibleImages && visibleImages.size < sources.length) {
      <a class="more-button" [class.!flex]="actionsAlwaysVisible">
        <button
          #menuTrigger
          [blazeIconButtonActive]="isMenuOpen"
          [matMenuTriggerFor]="menu"
          blazeIconButton="bat"
          class="bat-action-button"
        >
          <mat-icon svgIcon="icon_more_h_24" />
        </button>
      </a>
    }
    @if (canAddValue) {
      <a
        class="add-button"
        [class.!flex]="actionsAlwaysVisible"
        (click)="externalClickAction($event, undefined, undefined, true)"
      >
        <button blazeIconButton="bat" class="bat-action-button">
          <mat-icon svgIcon="icon_add_32" />
        </button>
        <span>Click to add new image</span>
      </a>
    }
  </div>
</div>

<mat-menu #menu class="bd-menu file-menu">
  <ng-template matMenuContent>
    @for (source of sources; track source) {
      <ng-container
        [ngTemplateOutlet]="dropdownFilesListTpl"
        [ngTemplateOutletContext]="{ $implicit: source }"
      />
    }
  </ng-template>
</mat-menu>

<ng-template #dropdownFilesListTpl let-source>
  <div
    #element
    (mouseout)="element.style.backgroundColor = cellStyles?.cellBackground || ''"
    (mouseover)="element.style.backgroundColor = cellStyles?.cellHoverBackground || ''"
    [style]="{ backgroundColor: cellStyles?.cellBackground }"
    class="file-option"
  >
    <div class="file-table-el" [style]="{ color: cellStyles?.cellColor }" #element>
      @if (source) {
        <img class="h-[35px]" [src]="source" [alt]="source" />
      }
    </div>
    <div class="file-actions">
      <mat-icon
        (click)="downloadFile($event, source)"
        (keydown.enter)="downloadFile($event, source)"
        class="download"
        svgIcon="download"
      />
      @if (useExternalClickAction) {
        <mat-icon
          (click)="deleteFileFromList($event, source, element)"
          (keydown.enter)="downloadFile($event, source)"
          class="delete"
          svgIcon="icon_trash_16"
        />
      }
    </div>
  </div>
</ng-template>

<ng-template #emptyThumbnail>
  <span class="empty-thumb">
    @if (emptyThumbnailIcon === 'ies-initials') {
      <ng-template [ngTemplateOutlet]="initialsTpl" />
    } @else if (emptyThumbnailIcon !== 'ies-custom-text') {
      <mat-icon
        [style.--icon-size]="'100%'"
        [svgIcon]="emptyThumbnailIcon"
        class="image-empty-state"
      />
    } @else {
      {{ emptyText }}
    }
  </span>
</ng-template>

<ng-template #initialsTpl>
  <div [style]="initialsStyles()" class="initials">{{ initials() }}</div>
</ng-template>
